import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import user from './modules/user'
import programs from './modules/programs'
import analytics from './modules/analytics'
import banners from './modules/banners'
import tagsPrograms from './modules/tagsPrograms'

import axios from 'axios'
import localforage from 'localforage'
import { guid } from '@/utils'

Vue.use(Vuex)

const checkUrl = 'https://ws.planethorror.es/allow-access/'

const store = new Vuex.Store({
  modules: {
    auth,
    user,
    programs,
    banners,
    analytics,
    tagsPrograms
  },
  state: {
    error: null,
    loading: false,
    deviceId: null,
    ip: null,
    ready: false,
    times: {},
    ip: null,
    info: null,
    infoType: null,
    infoEnable: null
  },
  mutations: {
    setError (state, payload) {
      state.error = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    READY (state) {
      if (state.ip === null) {
        state.ready = false
        state.loading = false
      }
    },
    SET_DEVICE_ID (state, deviceId) {
      state.deviceId = deviceId
    },
    SET_USER (state, user) {
      state.user = user
    },
    SET_DB (state, db) {
      state.db = db
    },
    SET_TAGS (state, tags) {
      state.tags = tags
    },
    SET_BANNERS (state, banners) {
      state.banners = banners
    },
    ip (state, ip) {
      state.ip = ip
    },
    info (state, info) {
      state.info = info
    },
    infoType (state, infoType) {
      state.infoType = infoType || 'error'
    },
    infoEnable (state, infoEnable) {
      state.infoEnable = infoEnable || true
    }
  },
  actions: {
    setInfo ({ commit }, { info, infoType }) {
      commit('info', info)
      commit('infoType', infoType)
      commit('infoEnable', true)
    },
    async initialize ({ commit, state }) {
      // Generate deviceId if need
      var deviceId = await localforage.getItem('deviceId')
      console.log('stored deviceId: ', deviceId)
      if (deviceId === null) {
        deviceId = guid()
        await localforage.setItem('deviceId', deviceId)
      }
      console.log('deviceId: ', deviceId)
      commit('SET_DEVICE_ID', deviceId)

      console.log('start')
      let ip = null
      if (process.env.NODE_ENV === 'development') {
        ip = 'localhost'
        commit('ip', ip)
      } else {
        commit('ip', window.ip)
      }

      commit('READY')
    }
  },
  getters: {
    ip: (state) => state.ip,
    info: (state) => state.info,
    infoType: (state) => state.infoType,
    deviceId: (state) => state.deviceId,
    infoEnable: (state) => state.infoEnable
  }
})

export default store
